(function () {
  'use strict';

  const isTouchDevice =
    'ontouchstart' in window || navigator.maxTouchPoints > 0;

  document.querySelectorAll('.co-mega-menu-wrapper').forEach(initMegaMenu);

  function initMegaMenu(wrapper) {
    const leftUl = wrapper.querySelector('.co-mega-menu-left-ul');
    const rightUl = wrapper.querySelector('.co-mega-menu-right-ul');
    const categoryItems = wrapper.querySelectorAll('.co-mega-menu-left-ul li');
    const mainButtons = wrapper.querySelectorAll(
      '.co-mega-menu-main-button-link'
    );
    const announcer = wrapper.querySelector('[aria-live="polite"]');
    const sourceEl = wrapper.querySelector('.co-mega-menu-frame-4');
    const targetEl = wrapper.querySelector('.co-mega-menu-frame-3');

    if (!leftUl || !rightUl || categoryItems.length === 0) return;

    // Height sync
    if (sourceEl && targetEl) {
      const updateHeight = () => {
        targetEl.style.setProperty(
          '--co-mega-menu-height',
          `${sourceEl.offsetHeight}px`
        );
      };
      updateHeight();
      const ro = new ResizeObserver(updateHeight);
      ro.observe(sourceEl);
    }

    // Touch tracking
    const touchedCategories = new Set();

    // Announce to screen readers
    function announce(message) {
      if (announcer) {
        announcer.textContent = message;
      }
    }

    // Switch active category
    function switchCategory(categoryLi) {
      const blockId = categoryLi.dataset.blockId;
      const categoryName =
        categoryLi.querySelector('a')?.textContent.trim() || '';

      // Deactivate all categories
      leftUl.querySelectorAll('li').forEach((li) => {
        li.classList.remove('co-active');
        li.querySelector('a')?.removeAttribute('aria-current');
      });

      // Activate selected category
      categoryLi.classList.add('co-active');
      categoryLi.querySelector('a')?.setAttribute('aria-current', 'true');

      // Deactivate all product lists
      rightUl.querySelectorAll(':scope > li').forEach((li) => {
        li.classList.remove('co-active');
        li.setAttribute('aria-hidden', 'true');
      });

      // Activate corresponding products
      const correspondingProducts = rightUl.querySelector(
        `li[data-block-id="${blockId}"]`
      );
      if (correspondingProducts) {
        correspondingProducts.classList.add('co-active');
        correspondingProducts.removeAttribute('aria-hidden');

        const productCount = correspondingProducts.querySelectorAll(
          '.co-mega-menu-article-title-frame a'
        ).length;
        announce(
          `${categoryName} selected. ${productCount} featured products available.`
        );
      }
    }

    // Get product links for a specific block
    function getProductLinksForBlock(blockId) {
      const productLi = rightUl.querySelector(
        `li[data-block-id="${blockId}"]`
      );
      if (!productLi) return [];
      return Array.from(
        productLi.querySelectorAll('.co-mega-menu-article-title-frame a')
      );
    }

    // --- Touch handling for category links ---
    if (isTouchDevice) {
      categoryItems.forEach((categoryLi) => {
        const categoryLink = categoryLi.querySelector('a');
        if (!categoryLink) return;

        let touchStart = 0;

        categoryLink.addEventListener(
          'touchstart',
          (e) => {
            touchStart = Date.now();
          },
          { passive: true }
        );

        categoryLink.addEventListener(
          'touchend',
          (e) => {
            const duration = Date.now() - touchStart;
            const blockId = categoryLi.dataset.blockId;

            if (duration < 500) {
              if (!touchedCategories.has(blockId)) {
                // First tap — switch category, prevent navigation
                e.preventDefault();
                switchCategory(categoryLi);
                touchedCategories.add(blockId);
              }
              // Second tap — allow default navigation
            }
          },
          { passive: false }
        );

        categoryLink.addEventListener('click', (e) => {
          const blockId = categoryLi.dataset.blockId;
          if (!touchedCategories.has(blockId)) {
            e.preventDefault();
          }
        });
      });
    }

    // --- Desktop hover on categories ---
    if (!isTouchDevice) {
      categoryItems.forEach((categoryLi) => {
        const categoryLink = categoryLi.querySelector('a');
        if (!categoryLink) return;

        categoryLink.addEventListener('mouseenter', () => {
          switchCategory(categoryLi);
        });
      });
    }

    // --- Keyboard: focus switches category ---
    categoryItems.forEach((categoryLi) => {
      const categoryLink = categoryLi.querySelector('a');
      if (!categoryLink) return;

      categoryLink.addEventListener('focus', () => {
        switchCategory(categoryLi);
      });
    });

    // --- Keep category active when focusing its products ---
    rightUl
      .querySelectorAll('.co-mega-menu-article-title-frame a')
      .forEach((productLink) => {
        productLink.addEventListener('focus', () => {
          const productLi = productLink.closest('li[data-block-id]');
          if (productLi) {
            const blockId = productLi.dataset.blockId;
            const categoryLi = leftUl.querySelector(
              `li[data-block-id="${blockId}"]`
            );
            if (categoryLi && !categoryLi.classList.contains('co-active')) {
              switchCategory(categoryLi);
            }
          }
        });
      });

    // --- Custom tab order ---
    function setupTabOrder() {
      const categoryArray = Array.from(categoryItems);

      categoryArray.forEach((categoryLi, index) => {
        const categoryLink = categoryLi.querySelector('a');
        if (!categoryLink) return;

        categoryLink.addEventListener('keydown', (e) => {
          const blockId = categoryLi.dataset.blockId;

          if (e.key === 'Tab' && !e.shiftKey) {
            // Tab forward — go to this category's products
            const productLinks = getProductLinksForBlock(blockId);
            if (productLinks.length > 0) {
              e.preventDefault();
              productLinks[0].focus();
            }
          } else if (e.key === 'Tab' && e.shiftKey) {
            // Shift+Tab — go to previous category
            if (index > 0) {
              e.preventDefault();
              categoryArray[index - 1].querySelector('a').focus();
            }
          }
        });
      });

      // Handle Tab within product links
      categoryItems.forEach((categoryLi) => {
        const blockId = categoryLi.dataset.blockId;
        const productLinks = getProductLinksForBlock(blockId);

        productLinks.forEach((productLink, productIndex) => {
          productLink.addEventListener('keydown', (e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
              if (productIndex < productLinks.length - 1) {
                // Next product
                e.preventDefault();
                productLinks[productIndex + 1].focus();
              } else if (mainButtons.length > 0) {
                // Last product — go to CTA button
                e.preventDefault();
                mainButtons[0].focus();
              } else {
                // No CTA — go to next category
                const catIndex = Array.from(categoryItems).findIndex(
                  (li) => li.dataset.blockId === blockId
                );
                if (catIndex < categoryItems.length - 1) {
                  e.preventDefault();
                  categoryItems[catIndex + 1].querySelector('a').focus();
                }
              }
            } else if (e.key === 'Tab' && e.shiftKey) {
              if (productIndex > 0) {
                // Previous product
                e.preventDefault();
                productLinks[productIndex - 1].focus();
              } else {
                // First product — back to its category
                e.preventDefault();
                const catLi = leftUl.querySelector(
                  `li[data-block-id="${blockId}"]`
                );
                catLi?.querySelector('a')?.focus();
              }
            }
          });
        });
      });

      // Handle Tab on CTA buttons
      mainButtons.forEach((button, btnIndex) => {
        button.addEventListener('keydown', (e) => {
          if (e.key === 'Tab' && !e.shiftKey) {
            if (btnIndex < mainButtons.length - 1) {
              e.preventDefault();
              mainButtons[btnIndex + 1].focus();
            } else {
              // Last button — go to next category
              const activeCategory = leftUl.querySelector('li.co-active');
              if (activeCategory) {
                const catIndex = Array.from(categoryItems).indexOf(activeCategory);
                if (catIndex < categoryItems.length - 1) {
                  e.preventDefault();
                  categoryItems[catIndex + 1].querySelector('a').focus();
                }
              }
            }
          } else if (e.key === 'Tab' && e.shiftKey) {
            if (btnIndex > 0) {
              e.preventDefault();
              mainButtons[btnIndex - 1].focus();
            } else {
              // First button — back to last product of active category
              const activeCategory = leftUl.querySelector('li.co-active');
              if (activeCategory) {
                const blockId = activeCategory.dataset.blockId;
                const productLinks = getProductLinksForBlock(blockId);
                if (productLinks.length > 0) {
                  e.preventDefault();
                  productLinks[productLinks.length - 1].focus();
                }
              }
            }
          }
        });
      });
    }

    // Reset touched categories when the mega menu's parent submenu closes
    const submenu = wrapper.closest('.menu-list__submenu');
    if (submenu) {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const visibility = getComputedStyle(submenu).visibility;
            if (visibility === 'hidden') {
              touchedCategories.clear();
              // Reset to first category
              const firstCategory = categoryItems[0];
              if (firstCategory) {
                switchCategory(firstCategory);
              }
            }
          }
        }
      });
      observer.observe(submenu, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    setupTabOrder();
  }
})();
